import React from 'react';

//material ui
import Divider from '@material-ui/core/Divider';

const LoginFormContentDivider = ({ classes }) => {
  return (
    <div style={{ width: '100%', display: 'flex' }}>
      <Divider
        className={classes.divider}
        style={{ backgroundColor: '#0075ba', height: '1px' }}
      />
      <p
        style={{
          marginRight: '8px',
          marginLeft: '8px',
          fontFamily: '"Alegreya Sans", sans-serif',
        }}
      >
        OR
      </p>
      <Divider
        className={classes.divider}
        style={{ backgroundColor: '#0075ba', height: '1px' }}
      />
    </div>
  );
};

export default LoginFormContentDivider;
